module.exports = __webpack_public_path__ + "2acfafdfbc50729889704adedb4a0ad2.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-118.png
// module id = 107
// module chunks = 0